import { render } from "./FeatureSectionFour.vue?vue&type=template&id=60f85f31"
import script from "./FeatureSectionFour.vue?vue&type=script&lang=js"
export * from "./FeatureSectionFour.vue?vue&type=script&lang=js"

import "./FeatureSectionFour.vue?vue&type=style&index=0&id=60f85f31&lang=css"

import exportComponent from "C:\\Users\\user\\Documents\\Progetti\\IFT-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__